export default __webpack_public_path__ + "static/media/icon-windows.5ebd168a.svg";